import type { AlertType } from "@/types/types";
import { createContext, type Dispatch, type SetStateAction } from "react";

export const NotifContext = createContext<{
    notif: AlertType | null;
    setNotif: Dispatch<SetStateAction<AlertType | null>>;
}>({
    notif: null,
    setNotif: () => null,
});
